enum loginStatusEnum {
	MFA_CHALLENGE = 'MFA_CHALLENGE',
	FAILURE = 'FAILURE',
	MFA_ENROLL_ACTIVATE = 'MFA_ENROLL_ACTIVATE'
}

export default loginStatusEnum